export { TreeItemIcon } from './TreeItemIcon';
export type {
  TreeItemIconProps,
  TreeItemIconSlots,
  TreeItemIconSlotProps,
} from './TreeItemIcon.types';
